const env = {
  // API_URL: "http://localhost:8084",
  API_URL: "https://script.crmgenix.com",
};
export default env;
